export const menus = [
  {
    code: "*",
    name: "dashboard_index",
    title: "控制台",
    link: "/dashboard/index",
    icon: "icon-kongzhitai"
  },
  {
    code: "*",
    name: "admin_list",
    title: "管理员",
    link: "/admin/index",
    icon: "icon-guanliyuan1"
  },
  {
    code: "*",
    name: "user_list",
    title: "用户管理",
    link: "/user/index",
    icon: "icon-yonghu"
  },
  {
    code: "*",
    name: "h5_recharge",
    title: "便捷充值",
    link: "/user/h5Recharge",
    icon: "icon-baojia"
  },
  {
    code: "*",
    name: "rechargePackage_list",
    title: "充值套餐",
    link: "/rechargePackage/index",
    icon: "icon-huodong1"
  },
  {
    code: "*",
    name: "query_list",
    title: "查询列表",
    link: "/queryList/index",
    icon: "icon-kuaijiedaohang-wenzhang"
  },
  {
    code: "*",
    name: "amount_list",
    title: "金额日志",
    link: "/amountList/index",
    icon: "icon-baojia"
  },
  {
    code: "*",
    name: "rechargeRecord",
    title: "充值记录",
    link: "/rechargeRecord/index",
    icon: "icon-baojia"
  },
  {
    code: "*",
    name: "orderManage",
    title: "订单管理",
    link: "/orderManage/index",
    icon: "icon-dingdan1"
  },
  {
    name: "article",
    title: "文章",
    code: "*",
    icon: "icon-wenzhang",
    child: [
      {
        name: "article_category_list",
        title: "分类",
        link: "/article/category/index"
      },
      {
        name: "article_list",
        title: "列表",
        link: "/article/index"
      }
    ]
  },
  {
    name: "operation",
    title: "运营管理",
    code: "*",
    link: "/operation/index",
    icon: "icon-wenzhang"
  },
  {
    name: "user_feedback",
    title: "用户反馈",
    code: "*",
    link: "/userFeed/UserFeedBack",
    icon: "icon-wenzhang"
  }

  /* {
        name: 'admin',
        title: '管理员',
        code: 'guanliyuan',
        icon: 'icon-guanliyuan1',
        child: [
            {
                name: 'admin_list',
                title: '管理员',
                link: '/admin/index',
            },
            {
                name: 'role_list',
                title: '角色',
                link: '/admin/role',
            },
            // {
            //     name: 'admin_worker',
            //     title: '员工',
            //     link: '/admin/worker',
            // },
        ],
    },*/
  /*    {
        name: 'recycle',
        title: '回收库',
        code: '*',
        icon: 'icon-huishouku',
        child: [
            {
                name: 'recycle_recycleone',
                title: '一级分类',
                link: '/recycle/recycleone/index',
            },
            {
                name: 'recycle_recycle',
                title: '品牌',
                link: '/recycle/recycle/index',
            },
            {
                name: 'recycle_templ',
                title: '模板',
                link: '/recycle/templ/index',
            },
            {
                name: 'recycle_product',
                title: '型号',
                link: '/recycle/product/index',
            },
            {
                name: 'recycle_qsprduct',
                title: '缺失产品',
                link: '/recycle/product/qsprduct',
            },
        ],
    },
    {
        name: 'littleCollect',
        title: '点点收',
        code: '*',
        icon: 'icon-huodong1',
        child: [
            {
                name: 'littleCollectList',
                title: '品牌和型号',
                link: '/littleCollect/classify/index',
            },
            {
                name: 'littleCollect_product',
                title: '型号',
                link: '/littleCollect/product/index',
            },
        ],
    },
    {
        name: 'idlegoodsman',
        title: '闲品侠',
        code: '*',
        icon: 'icon-fenjian-line',
        child: [
            {
                name: 'idlegoodsmanList',
                title: '分类',
                link: '/idlegoodsman/classify/index',
            },
            {
                name: 'idlegoodsman_product',
                title: '产品',
                link: '/idlegoodsman/product/index',
            },
        ],
    },
    {
        name: 'quotation',
        title: '报价单',
        code: '*',
        icon: 'icon-baojia',
        child: [
            {
                name: 'quotationList',
                title: '分类',
                link: '/quotation/classify/index',
            },
            {
                name: 'quotation_product',
                title: '产品',
                link: '/quotation/product/index',
            },
        ],
    },*/
];
